module.exports = __webpack_public_path__ + "img/couples-058.697ec52d.jpg";